// extracted by mini-css-extract-plugin
export default {"app":"charactersRoutes_app__QzDMi","content":"charactersRoutes_content__m+m22"};